import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import lodashGet from 'lodash/get';
import { memo } from 'react';
import { FaMinusCircle } from 'react-icons/fa';
function SignalAssignmentsColumn({ row, onHover, assignment, highlight, onUnlinkVisibilityChange, unlinkVisibility, onLink, onUnlink, }) {
    const diaIDs = lodashGet(row, 'tableMetaInfo.signal.diaIDs', []);
    const tdCss = assignment.isActive || highlight.isActive
        ? {
            color: 'red',
            fontWeight: 'bold',
        }
        : {};
    function visibilityChangeHandler(flag) {
        onUnlinkVisibilityChange?.(flag);
    }
    function assignHandler(e) {
        onLink?.(e, assignment);
    }
    return (_jsx("td", { ...onHover, onClick: assignHandler, style: { padding: '0', ...tdCss }, children: diaIDs && diaIDs.length > 0 ? (_jsxs("div", { onMouseEnter: () => visibilityChangeHandler(true), onMouseLeave: () => visibilityChangeHandler(false), children: [_jsx("span", { children: diaIDs.length }), _jsx("sup", { children: _jsx("button", { type: "button", style: {
                            visibility: unlinkVisibility ? 'visible' : 'hidden',
                            padding: 0,
                            margin: 0,
                        }, onClick: (e) => onUnlink?.(e, false), children: _jsx(FaMinusCircle, { color: "red" }) }) })] })) : assignment.isActive ? ('0') : ('') }));
}
export default memo(SignalAssignmentsColumn);
